import { useState, useEffect } from "react";
/**
 * Custom hook to handle sessionStorage
 * @param {*} storageKey - the key to use in sessionStorage
 * @param {*} fallbackState - the fallback state if no value is stored
 * @returns {[any, function]} - An array with the current value and a function to update it
 */
const useSessionStorage = (storageKey, fallbackState) => {
    const [value, setValue] = useState(
        JSON.parse(sessionStorage.getItem(storageKey)) ?? fallbackState
    );

    useEffect(() => {
        sessionStorage.setItem(storageKey, JSON.stringify(value));
    }, [value, storageKey]);

    return [value, setValue];
};

export default useSessionStorage;
